import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPostVodafoneServices } from '../models/models'

export class GetAuthorizedServicesVodafoneApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/authorizedServicesVodafone/listAllVodafoneServices',
      requesterInfo,
    })
  }

  public async getAuthorizedServicesMain(): Promise<IPostVodafoneServices[]> {
    return await this.getAsync<IPostVodafoneServices[]>()
  }
}
